
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.458 6.75c-1.171-.026-2.07-.547-2.695-1.563-.573-1.041-.573-2.083 0-3.125C4.388 1.048 5.287.526 6.46.5c1.171.026 2.07.547 2.695 1.563.573 1.041.573 2.083 0 3.124C8.529 6.204 7.63 6.724 6.458 6.75zm14.375 0c-1.171-.026-2.07-.547-2.695-1.563-.573-1.041-.573-2.083 0-3.125C18.763 1.048 19.662.526 20.833.5c1.172.026 2.07.547 2.696 1.563.573 1.041.573 2.083 0 3.124-.625 1.016-1.524 1.537-2.695 1.563zm-20 5.43c.027-1.198.43-2.188 1.211-2.97.782-.78 1.771-1.184 2.97-1.21h1.64c.625 0 1.21.13 1.758.39a4.795 4.795 0 00-.079.86c.053 1.537.612 2.787 1.68 3.75h-8.36c-.494-.052-.767-.325-.82-.82zm15.82.82c1.069-.963 1.628-2.213 1.68-3.75 0-.286-.025-.573-.078-.86A4.036 4.036 0 0120.013 8h1.64c1.199.026 2.188.43 2.97 1.21.78.782 1.184 1.772 1.21 2.97-.052.495-.325.768-.82.82h-8.36zm-3.32-5.625c-.703.026-1.25.339-1.64.938-.313.624-.313 1.25 0 1.874.39.6.937.912 1.64.938.704-.026 1.25-.338 1.641-.938.313-.624.313-1.25 0-1.874-.39-.6-.937-.912-1.64-.938zm0 5.625a3.62 3.62 0 01-1.874-.508A3.759 3.759 0 019.584 9.25a3.758 3.758 0 011.875-3.242 3.62 3.62 0 011.875-.508c.677 0 1.302.17 1.875.508a3.759 3.759 0 011.875 3.242 3.759 3.759 0 01-1.875 3.242 3.62 3.62 0 01-1.875.508zm-2.304 3.125c-.781.026-1.459.26-2.031.703a3.215 3.215 0 00-1.172 1.797H18.84a3.215 3.215 0 00-1.172-1.797c-.573-.443-1.25-.677-2.03-.703h-4.61zm0-1.875h4.61c1.457.026 2.681.534 3.671 1.523.99.99 1.498 2.214 1.524 3.672-.053.651-.404 1.003-1.055 1.055H6.889c-.652-.052-1.003-.404-1.056-1.055.027-1.458.534-2.682 1.524-3.672.99-.99 2.213-1.497 3.672-1.523z","fill":"#00DA5F"}})])
          )
        }
      }
    